import React from "react";
import { Box, Stack, Button, Typography, Paper } from "@mui/material";
import "theme/installer.css";
import ActionButton from "common/components/ActionButton";
import E1Input from "common/components/E1Input";
import Input from "common/components/Input";
import { styled } from "@mui/material/styles";
import useFetcher from "common/hooks/useFetcher";
import { MiniLoader } from "common/components/Loader";
import useScopeAttributes from "common/hooks/useScopeAttributes";
import useForm from "common/hooks/useForm";
import toast from "react-hot-toast";
import useState from "common/hooks/useState";
import { theme } from "theme";
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: theme.spacing(3),
  borderRadius: theme.spacing(1),
}));

import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { useNavigate } from "react-router-dom";

export default function ImportWizard({ config, importFile, onClose }) {
  const { variables, loading: variablesLoading } = useState("/api/vars");
  const [newId, setNewId] = React.useState(null);
  const {
    controller: envscontroller,
    getFormValues: getEnvsFormValues,
    setFormValues,
  } = useForm("envs");
  const {
    tags,
    TagInput,
    loading: attrLoading,
    setInit,
  } = useScopeAttributes();
  const navigate = useNavigate();
  const [formData, setFormData] = React.useState({
    name: config?.data?.name || "",
    description: config?.data?.description || "",
    envs: {},
  });
  const [envs, setEnvs] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const fetcher = useFetcher();
  React.useEffect(() => {
    let vars = variables?.map((v) => v.name);
    setEnvs(config?.envs?.filter((e) => !vars?.includes(e.name)) || []);
  }, [config, variablesLoading]);
  const [completed, setCompleted] = React.useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const installHandler = async () => {
    setLoading(true);
    const payload = {
      ...formData,
      envs: getEnvsFormValues(),
    };
    payload.tags = tags;

    if (formData?.name?.trim()?.length <= 2) {
      toast.error("name must be filled out");
      return setLoading(false);
    }

    try {
      await fetcher.post(
        "installing resource",
        config?.type === "system"
          ? `/api/trade/import/system`
          : `/api/trade/import/package`,
        () => {
          let form = new FormData();
          form.append("json", JSON.stringify(payload));
          form.append("file", importFile);
          return form;
        },
        ({ id, error }) => {
          if (error) {
            toast.error(error);
            setLoading(false);
            return;
          }
          setNewId(id);
          setCompleted(true);
        },
        () => {}
      );
    } catch {}
    setLoading(false);
  };
  if (completed) {
    return (
      <StyledPaper elevation={3}>
        <Stack p={2} alignItems={"center"} gap={1}>
          <div
            style={{ height: "250px", width: "250px", position: "relative" }}
          >
            <svg
              height="250px"
              width="250px"
              viewBox="0 0 512 512"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              xmlSpace="preserve"
              style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
                strokeLinejoin: "round",
                strokeMiterlimit: 2,
                position: "absolute",
                inset: 0,
              }}
            >
              <path
                d="M399.334,364.428C411.923,377.776 419.074,393.075 419.074,409.357C419.074,461.347 346.06,503.486 256.004,503.486C165.935,503.486 92.922,461.347 92.922,409.357C92.922,393.075 100.074,377.775 112.675,364.428"
                style={{
                  fill: "rgba(169, 38, 250, 0.13)",
                  fillRule: "nonzero",
                }}
              />
              <g transform="matrix(1.00861,0,0,0.871403,-3.44876,58.9438)">
                <path
                  d="M348.067,310.681C380.086,325.981 400.483,349.09 400.483,374.958C400.483,421.018 335.798,458.36 256.005,458.36C176.201,458.36 111.516,421.017 111.516,374.958C111.516,349.079 131.935,325.947 163.988,310.647L348.067,310.681Z"
                  style={{ fill: "#ff711a", fillRule: "nonzero" }}
                />
              </g>
              <path
                d="M402.318,361.56C402.517,362.325 402.897,363.03 403.426,363.618C415.939,377.519 422.652,393.261 422.652,409.358C422.652,436.132 404.822,460.705 373.1,479.015C341.693,497.144 300.098,507.062 256.007,507.062C211.91,507.062 170.311,497.144 138.904,479.015C138.904,479.015 138.904,479.015 138.904,479.015C107.18,460.705 89.35,436.132 89.35,409.358C89.35,393.264 96.061,377.529 108.569,363.638C109.098,363.05 109.479,362.343 109.678,361.577C109.827,361.005 110.335,360.437 110.95,359.739C112.028,358.517 113.499,357.205 115.288,355.799C121.307,351.069 130.657,345.526 141.704,339.665C181.545,318.529 243.102,293.642 254.357,289.136C265.778,293.606 328.842,318.529 369.611,339.683C380.909,345.545 390.468,351.09 396.613,355.818C398.441,357.225 399.942,358.537 401.041,359.759C401.658,360.445 402.171,360.997 402.318,361.56ZM262.891,349.399C259.657,335.415 252.802,328.135 245.254,324.498C231.385,317.815 213.868,323.939 208.114,325.69C207.987,325.729 207.837,325.771 207.708,325.807C207.322,325.817 206.935,325.873 206.555,325.976C206.555,325.976 162.862,337.815 136.641,352.036C129.408,355.959 123.463,360.119 119.826,364.212C116.654,367.781 115.089,371.456 115.089,374.958C115.089,395.528 129.196,415.584 155.619,430.836C155.62,430.836 155.62,430.836 155.621,430.837C156.725,431.474 157.408,432.656 157.408,433.931C157.408,434.558 157.243,435.174 156.929,435.717C156.928,435.718 156.928,435.719 156.928,435.719C156.29,436.824 155.109,437.506 153.834,437.506C153.207,437.506 152.59,437.341 152.047,437.028C152.047,437.028 152.047,437.027 152.047,437.027C129.66,424.104 115.048,407.67 109.946,389.44C109.378,387.41 107.584,385.964 105.479,385.841C103.374,385.718 101.424,386.945 100.623,388.895C97.884,395.565 96.497,402.399 96.497,409.358C96.497,432.801 112.542,455.546 142.475,472.822C172.663,490.246 212.972,499.912 256.005,499.912C299.033,499.912 339.337,490.247 369.524,472.823L369.524,472.823C399.454,455.546 415.499,432.801 415.501,409.358C415.501,409.358 415.501,409.358 415.501,409.358C415.501,402.399 414.114,395.566 411.376,388.895C410.576,386.944 408.625,385.717 406.52,385.84C404.415,385.963 402.621,387.409 402.052,389.44C396.952,407.67 382.34,424.106 359.954,437.028C359.954,437.028 359.954,437.028 359.954,437.028C332.059,453.132 295.133,461.936 256.006,461.936C227.904,461.936 200.55,457.328 176.904,448.581C175.52,448.055 174.6,446.721 174.6,445.24C174.6,443.279 176.214,441.665 178.175,441.665C178.584,441.665 178.989,441.735 179.374,441.872C202.187,450.31 228.678,454.786 256.006,454.786C294.068,454.786 329.704,446.235 356.38,430.836C382.803,415.582 396.909,395.528 396.909,374.958C396.909,371.44 395.068,367.542 391.199,363.738C386.872,359.484 379.782,355.01 371.177,350.68C339.516,334.746 286.754,319.992 286.754,319.992C284.627,319.398 282.364,320.289 281.212,322.174C276.607,329.711 268.504,341.421 262.891,349.399Z"
                style={{ fillRule: "nonzero" }}
              />
              <g transform="matrix(1,0,0,0.833561,0,71.5663)">
                <path
                  d="M256.004,429.984C222.799,429.984 190.728,422.466 168.018,409.356C150.142,399.037 139.891,386.5 139.891,374.958C139.891,365.467 147.11,355.119 159.518,346.076C164.696,342.302 170.337,339.209 176.217,336.663L256.006,302.107L335.809,336.686C341.694,339.236 347.341,342.333 352.522,346.114C364.904,355.149 372.107,365.482 372.107,374.957C372.107,386.498 361.855,399.037 343.98,409.355C321.27,422.465 289.204,429.984 256.004,429.984Z"
                  style={{ fill: "#fbb56f", fillRule: "nonzero" }}
                />
              </g>
              <g>
                <g transform="matrix(1,0,0,1,0,28)">
                  {/* <path
                d="M400.487,133.922L256.02,217.324L111.542,133.911L256.02,50.509L400.487,133.922Z"
                style={{ fill: "#bb1fe2", fillRule: "nonzero" }}
              /> */}
                </g>
                <g transform="matrix(1,0,0,1,0,28)">
                  <path
                    d="M400.487,133.922L376.322,291.09L256.009,374.503L255.997,374.492L256.02,217.324L400.487,133.922Z"
                    style={{ fill: "#6a157f", fillRule: "nonzero" }}
                  />
                </g>
                <g transform="matrix(1,0,0,1,0,28)">
                  <path
                    d="M256.02,217.324L255.997,374.492L135.718,291.033L111.542,133.911L256.02,217.324Z"
                    style={{ fill: "#6a157f", fillRule: "nonzero" }}
                  />
                </g>
                <g transform="matrix(1,0,0,1,0,28)">
                  <path
                    d="M402.439,130.064C402.53,130.129 402.623,130.192 402.719,130.25C402.794,130.295 402.919,130.366 402.998,130.41C404.318,131.355 405.001,132.971 404.753,134.58C404.753,134.58 394.73,199.775 394.73,199.775C394.367,202.135 392.161,203.748 389.8,203.39C387.458,203.028 385.828,200.804 386.188,198.462C386.188,198.462 393.516,150.802 393.516,150.802C393.761,149.208 393.07,147.616 391.739,146.705C390.409,145.795 388.674,145.729 387.277,146.535L262.437,218.607C261.141,219.356 260.342,220.739 260.342,222.236L260.325,358.249C260.324,359.809 261.19,361.24 262.572,361.963C263.953,362.687 265.622,362.583 266.904,361.694L370.849,289.626C371.794,288.971 372.429,287.956 372.604,286.819L380.799,233.517C381.162,231.158 383.373,229.545 385.729,229.903C388.071,230.265 389.701,232.489 389.341,234.831C389.341,234.831 380.591,291.749 380.591,291.749C380.413,292.901 379.778,293.932 378.833,294.609C376.341,296.256 278.468,360.912 255.933,376.591L133.226,294.563C132.266,293.888 131.621,292.85 131.443,291.689L107.265,134.568C106.994,132.81 107.835,131.057 109.376,130.168L253.86,46.767C255.195,45.996 256.845,45.996 258.18,46.767L402.439,130.064ZM124.747,146.526C123.35,145.72 121.615,145.786 120.285,146.697C118.954,147.607 118.263,149.2 118.508,150.793L139.429,286.76C139.603,287.886 140.226,288.892 141.156,289.548L244.347,362.339C245.623,363.239 247.294,363.355 248.682,362.641C250.07,361.926 250.946,360.498 250.955,358.937L251.699,222.26C251.707,220.754 250.907,219.36 249.604,218.607L186.858,182.384C185.523,181.613 184.698,180.184 184.698,178.642C184.698,177.884 184.897,177.139 185.277,176.482C185.277,176.481 185.277,176.481 185.278,176.48C186.47,174.413 189.112,173.707 191.18,174.9C191.18,174.9 253.924,211.123 253.924,211.123C255.221,211.871 256.819,211.871 258.116,211.123L385.554,137.551C386.85,136.802 387.649,135.419 387.649,133.921C387.649,132.424 386.851,131.04 385.554,130.291L258.115,56.709C256.818,55.961 255.22,55.96 253.924,56.709L126.47,130.282C125.173,131.031 124.374,132.414 124.374,133.912C124.374,135.409 125.173,136.793 126.469,137.542L166.059,160.398C167.394,161.169 168.219,162.598 168.219,164.14C168.219,164.898 168.02,165.643 167.64,166.3C167.64,166.3 167.64,166.3 167.64,166.301C166.869,167.636 165.44,168.461 163.898,168.461C163.14,168.461 162.395,168.261 161.738,167.882L124.747,146.526Z"
                    style={{ fillRule: "nonzero" }}
                  />
                </g>
              </g>
            </svg>
            <Box
              className="holo-hover"
              sx={{
                // position: "relative",
                position: "absolute",
                top: "20px",
                left: "87px",
                width: 80,
                height: 80,
                borderRadius: "50%",
                // width: "fit-content",
                "@keyframes glowPulse": {
                  "0%": {
                    opacity: 0.7,
                    boxShadow: "0 0 10px rgba(138, 43, 226, 0.5)",
                  },
                  "50%": {
                    opacity: 1,
                    boxShadow: "0 0 20px rgba(138, 43, 226, 0.8)",
                  },
                  "100%": {
                    opacity: 0.7,
                    boxShadow: "0 0 10px rgba(138, 43, 226, 0.5)",
                  },
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: -2,
                  left: -2,
                  right: -2,
                  bottom: -2,
                  borderRadius: "32px",
                  background: "linear-gradient(45deg, #8a2be2, #da70d6)",
                  boxShadow: "0 0 15px rgba(138, 43, 226, 0.7)",
                  animation: "glowPulse 3s infinite ease-in-out",
                  zIndex: 0,
                },
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  backgroundColor: theme.palette.primary.dark,

                  mb: 3,
                }}
              >
                <RocketLaunchIcon
                  sx={{
                    fontSize: 50,
                    color: theme.palette.secondary.main,
                    animation: `
                pulse 2s ease-in-out infinite,
                glow 2s ease-in-out infinite
              `,
                    transformOrigin: "center",
                  }}
                />
              </Box>
            </Box>
          </div>
          <Typography fontSize={"32px"} fontWeight={"bold"} variant="h3">
            {`${
              config?.type === "system" ? "System" : "Package"
            } installed`.toUpperCase()}
          </Typography>
          <Button
            onClick={() => {
              navigate(
                `/app/${
                  config?.type === "system" ? "sys" : "packages"
                }/${newId}${config?.type === "system" ? "/dash" : ""}`
              );
            }}
            variant="contained"
            color="secondary"
            sx={{
              marginTop: "24px",
              textTransform: "none",
              px: 4,
              py: 1,
              borderRadius: 2,
              letterSpacing: "1.2px",
            }}
          >
            CONTINUE TO {config?.type === "system" ? "SYSTEM" : "PACKAGE"}
          </Button>
        </Stack>
      </StyledPaper>
    );
  }
  if (loading) {
    return (
      <StyledPaper sx={{ height: "323px" }} elevation={3}>
        <div
          style={{
            marginTop: "120px",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MiniLoader />
        </div>
      </StyledPaper>
    );
  }
  return (
    <StyledPaper elevation={3}>
      <Stack gap={4}>
        <Stack gap={1} justifyContent={"center"} alignItems={"center"}>
          <svg
            height="250px"
            width="250px"
            viewBox="0 0 512 512"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
            style={{
              fillRule: "evenodd",
              clipRule: "evenodd",
              strokeLinejoin: "round",
              strokeMiterlimit: 2,
            }}
          >
            <path
              d="M399.334,364.428C411.923,377.776 419.074,393.075 419.074,409.357C419.074,461.347 346.06,503.486 256.004,503.486C165.935,503.486 92.922,461.347 92.922,409.357C92.922,393.075 100.074,377.775 112.675,364.428"
              style={{ fill: "rgba(169, 38, 250, 0.13)", fillRule: "nonzero" }}
            />
            <g transform="matrix(1.00861,0,0,0.871403,-3.44876,58.9438)">
              <path
                d="M348.067,310.681C380.086,325.981 400.483,349.09 400.483,374.958C400.483,421.018 335.798,458.36 256.005,458.36C176.201,458.36 111.516,421.017 111.516,374.958C111.516,349.079 131.935,325.947 163.988,310.647L348.067,310.681Z"
                style={{ fill: "#ff711a", fillRule: "nonzero" }}
              />
            </g>
            <path
              d="M402.318,361.56C402.517,362.325 402.897,363.03 403.426,363.618C415.939,377.519 422.652,393.261 422.652,409.358C422.652,436.132 404.822,460.705 373.1,479.015C341.693,497.144 300.098,507.062 256.007,507.062C211.91,507.062 170.311,497.144 138.904,479.015C138.904,479.015 138.904,479.015 138.904,479.015C107.18,460.705 89.35,436.132 89.35,409.358C89.35,393.264 96.061,377.529 108.569,363.638C109.098,363.05 109.479,362.343 109.678,361.577C109.827,361.005 110.335,360.437 110.95,359.739C112.028,358.517 113.499,357.205 115.288,355.799C121.307,351.069 130.657,345.526 141.704,339.665C181.545,318.529 243.102,293.642 254.357,289.136C265.778,293.606 328.842,318.529 369.611,339.683C380.909,345.545 390.468,351.09 396.613,355.818C398.441,357.225 399.942,358.537 401.041,359.759C401.658,360.445 402.171,360.997 402.318,361.56ZM262.891,349.399C259.657,335.415 252.802,328.135 245.254,324.498C231.385,317.815 213.868,323.939 208.114,325.69C207.987,325.729 207.837,325.771 207.708,325.807C207.322,325.817 206.935,325.873 206.555,325.976C206.555,325.976 162.862,337.815 136.641,352.036C129.408,355.959 123.463,360.119 119.826,364.212C116.654,367.781 115.089,371.456 115.089,374.958C115.089,395.528 129.196,415.584 155.619,430.836C155.62,430.836 155.62,430.836 155.621,430.837C156.725,431.474 157.408,432.656 157.408,433.931C157.408,434.558 157.243,435.174 156.929,435.717C156.928,435.718 156.928,435.719 156.928,435.719C156.29,436.824 155.109,437.506 153.834,437.506C153.207,437.506 152.59,437.341 152.047,437.028C152.047,437.028 152.047,437.027 152.047,437.027C129.66,424.104 115.048,407.67 109.946,389.44C109.378,387.41 107.584,385.964 105.479,385.841C103.374,385.718 101.424,386.945 100.623,388.895C97.884,395.565 96.497,402.399 96.497,409.358C96.497,432.801 112.542,455.546 142.475,472.822C172.663,490.246 212.972,499.912 256.005,499.912C299.033,499.912 339.337,490.247 369.524,472.823L369.524,472.823C399.454,455.546 415.499,432.801 415.501,409.358C415.501,409.358 415.501,409.358 415.501,409.358C415.501,402.399 414.114,395.566 411.376,388.895C410.576,386.944 408.625,385.717 406.52,385.84C404.415,385.963 402.621,387.409 402.052,389.44C396.952,407.67 382.34,424.106 359.954,437.028C359.954,437.028 359.954,437.028 359.954,437.028C332.059,453.132 295.133,461.936 256.006,461.936C227.904,461.936 200.55,457.328 176.904,448.581C175.52,448.055 174.6,446.721 174.6,445.24C174.6,443.279 176.214,441.665 178.175,441.665C178.584,441.665 178.989,441.735 179.374,441.872C202.187,450.31 228.678,454.786 256.006,454.786C294.068,454.786 329.704,446.235 356.38,430.836C382.803,415.582 396.909,395.528 396.909,374.958C396.909,371.44 395.068,367.542 391.199,363.738C386.872,359.484 379.782,355.01 371.177,350.68C339.516,334.746 286.754,319.992 286.754,319.992C284.627,319.398 282.364,320.289 281.212,322.174C276.607,329.711 268.504,341.421 262.891,349.399Z"
              style={{ fillRule: "nonzero" }}
            />
            <g transform="matrix(1,0,0,0.833561,0,71.5663)">
              <path
                d="M256.004,429.984C222.799,429.984 190.728,422.466 168.018,409.356C150.142,399.037 139.891,386.5 139.891,374.958C139.891,365.467 147.11,355.119 159.518,346.076C164.696,342.302 170.337,339.209 176.217,336.663L256.006,302.107L335.809,336.686C341.694,339.236 347.341,342.333 352.522,346.114C364.904,355.149 372.107,365.482 372.107,374.957C372.107,386.498 361.855,399.037 343.98,409.355C321.27,422.465 289.204,429.984 256.004,429.984Z"
                style={{ fill: "#fbb56f", fillRule: "nonzero" }}
              />
            </g>
            <g className="holo-hover">
              <g transform="matrix(1,0,0,1,0,28)">
                <path
                  d="M400.487,133.922L256.02,217.324L111.542,133.911L256.02,50.509L400.487,133.922Z"
                  style={{ fill: "#bb1fe2", fillRule: "nonzero" }}
                />
              </g>
              <g transform="matrix(1,0,0,1,0,28)">
                <path
                  d="M400.487,133.922L376.322,291.09L256.009,374.503L255.997,374.492L256.02,217.324L400.487,133.922Z"
                  style={{ fill: "#6a157f", fillRule: "nonzero" }}
                />
              </g>
              <g transform="matrix(1,0,0,1,0,28)">
                <path
                  d="M256.02,217.324L255.997,374.492L135.718,291.033L111.542,133.911L256.02,217.324Z"
                  style={{ fill: "#6a157f", fillRule: "nonzero" }}
                />
              </g>
              <g transform="matrix(1,0,0,1,0,28)">
                <path
                  d="M402.439,130.064C402.53,130.129 402.623,130.192 402.719,130.25C402.794,130.295 402.919,130.366 402.998,130.41C404.318,131.355 405.001,132.971 404.753,134.58C404.753,134.58 394.73,199.775 394.73,199.775C394.367,202.135 392.161,203.748 389.8,203.39C387.458,203.028 385.828,200.804 386.188,198.462C386.188,198.462 393.516,150.802 393.516,150.802C393.761,149.208 393.07,147.616 391.739,146.705C390.409,145.795 388.674,145.729 387.277,146.535L262.437,218.607C261.141,219.356 260.342,220.739 260.342,222.236L260.325,358.249C260.324,359.809 261.19,361.24 262.572,361.963C263.953,362.687 265.622,362.583 266.904,361.694L370.849,289.626C371.794,288.971 372.429,287.956 372.604,286.819L380.799,233.517C381.162,231.158 383.373,229.545 385.729,229.903C388.071,230.265 389.701,232.489 389.341,234.831C389.341,234.831 380.591,291.749 380.591,291.749C380.413,292.901 379.778,293.932 378.833,294.609C376.341,296.256 278.468,360.912 255.933,376.591L133.226,294.563C132.266,293.888 131.621,292.85 131.443,291.689L107.265,134.568C106.994,132.81 107.835,131.057 109.376,130.168L253.86,46.767C255.195,45.996 256.845,45.996 258.18,46.767L402.439,130.064ZM124.747,146.526C123.35,145.72 121.615,145.786 120.285,146.697C118.954,147.607 118.263,149.2 118.508,150.793L139.429,286.76C139.603,287.886 140.226,288.892 141.156,289.548L244.347,362.339C245.623,363.239 247.294,363.355 248.682,362.641C250.07,361.926 250.946,360.498 250.955,358.937L251.699,222.26C251.707,220.754 250.907,219.36 249.604,218.607L186.858,182.384C185.523,181.613 184.698,180.184 184.698,178.642C184.698,177.884 184.897,177.139 185.277,176.482C185.277,176.481 185.277,176.481 185.278,176.48C186.47,174.413 189.112,173.707 191.18,174.9C191.18,174.9 253.924,211.123 253.924,211.123C255.221,211.871 256.819,211.871 258.116,211.123L385.554,137.551C386.85,136.802 387.649,135.419 387.649,133.921C387.649,132.424 386.851,131.04 385.554,130.291L258.115,56.709C256.818,55.961 255.22,55.96 253.924,56.709L126.47,130.282C125.173,131.031 124.374,132.414 124.374,133.912C124.374,135.409 125.173,136.793 126.469,137.542L166.059,160.398C167.394,161.169 168.219,162.598 168.219,164.14C168.219,164.898 168.02,165.643 167.64,166.3C167.64,166.3 167.64,166.3 167.64,166.301C166.869,167.636 165.44,168.461 163.898,168.461C163.14,168.461 162.395,168.261 161.738,167.882L124.747,146.526Z"
                  style={{ fillRule: "nonzero" }}
                />
              </g>
            </g>
          </svg>

          <Typography fontSize={"32px"} fontWeight={"bold"} variant="h3">
            {`Import ${
              config?.type === "system" ? "System" : "Package"
            }`.toUpperCase()}
          </Typography>
          <Typography variant="body1" gutterBottom>
            Provide installation information for the{" "}
            <strong>{config?.data?.name}</strong>{" "}
            {config?.type === "system" ? "system" : "package"}
          </Typography>
        </Stack>

        <Stack gap={4}>
          <Input
            dark
            label={`${config?.type === "system" ? "System" : "Package"} Name`}
            size="small"
            name="name"
            fullWidth
            autoFocus
            //   sx={{ width: "100%" }}
            placeholder="Name"
            value={formData.name}
            onChange={handleInputChange}
          />
          {config?.type === "package" ? (
            <Input
              dark
              label={`Description`}
              size="small"
              name="description"
              multiline
              minRows={3}
              maxRows={3}
              fullWidth
              autoFocus
              placeholder="Description"
              value={formData.description}
              onChange={handleInputChange}
            />
          ) : null}
        </Stack>
        {envs?.length ? (
          <Stack gap={1}>
            <Typography variant="h6" gutterBottom>
              Required Variables
            </Typography>
            <Typography variant="body1" gutterBottom>
              The following required variables will be created in your Echelon
              One instance and referenced by this system after installation.
            </Typography>
            {envs?.map((env) => (
              <Stack mb={2} key={env.name}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <Typography
                    variant="overline"
                    sx={{ lineHeight: 1.5, fontWeight: "bold" }}
                  >
                    Name:
                  </Typography>
                  <Typography variant="body2">{env.name}</Typography>
                </Stack>
                <Stack
                  mb={2}
                  direction={"row"}
                  alignItems={"center"}
                  spacing={1}
                >
                  <Typography
                    variant="overline"
                    sx={{ lineHeight: 1.5, fontWeight: "bold" }}
                  >
                    Description:
                  </Typography>
                  <Typography variant="body2">{env.description}</Typography>
                </Stack>
                <E1Input
                  sx={{ width: "100%" }}
                  type={envs?.type || "str"}
                  label={`Value`}
                  inputProps={{ ...envscontroller(env.name) }}
                />
              </Stack>
            ))}
          </Stack>
        ) : null}
        <TagInput size="small" dark />
        <div style={{ marginLeft: "auto" }}>
          <ActionButton
            icon="arrow_circle_down"
            noload
            dark
            handler={async () => {
              installHandler();
            }}
          >
            Install {config?.type}
          </ActionButton>
        </div>
      </Stack>
    </StyledPaper>
  );
}
